import type { FC } from "react";
import { useState } from "react";

import { IconButton } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledContactUsContainer,
    StyledContactUsFinalContainer,
    StyledGainAccessBtnWrapper,
    StyledGainAccessSubTitle,
    StyledGainAccessTitle,
} from "./styles";
import { SuccessHookBlock } from "./SuccesHookBlock/SuccessHookBlock";

interface ContactUsHookProps {
    title: string;
    subTitle: string;
    onClick: VoidFunction;
}

const ContactUsHook: FC<ContactUsHookProps> = ({ title, subTitle, onClick }) => {
    const [isShowContactUsFinalStep, setIsShowContactUsFinalStep] = useState<boolean>(false);

    const handleShowContactUsFinalStep = () => {
        setIsShowContactUsFinalStep(true);
        onClick?.();
    };

    if (isShowContactUsFinalStep) {
        return (
            <StyledContactUsFinalContainer>
                <SuccessHookBlock
                    title={translate("hook_modal.get_feature.success.title")}
                    subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                />
            </StyledContactUsFinalContainer>
        );
    }

    return (
        <StyledContactUsContainer>
            <div>
                <img
                    src={AssetsService.assetUrl("/images/gain-access-crm-lock.svg")}
                    alt="Contact us"
                    width={228}
                />
            </div>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessTitle}
            >
                {title}
            </I18n>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessSubTitle}
            >
                {subTitle}
            </I18n>
            <StyledGainAccessBtnWrapper>
                <IconButton
                    iconName="sparkles-gray"
                    type="trial"
                    onClick={handleShowContactUsFinalStep}
                >
                    {translate("si.common.contact_us")}
                </IconButton>
            </StyledGainAccessBtnWrapper>
        </StyledContactUsContainer>
    );
};

export default ContactUsHook;
